export const renderHour = (date?: string) => {
	if (date?.includes('T')) {
		return date.split('T')[1].split('.')[0].substring(0, 5);
	}
};
